/* THE SIGN — trust-bar: animacja count-up przy wejściu w viewport.
   Progresywne ulepszenie: wartość docelowa jest w HTML; JS animuje od 0.
   Respektuje prefers-reduced-motion. Vanilla JS, bez zależności. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setFinal(el) {
    el.textContent = (el.getAttribute('data-count') || '') + (el.getAttribute('data-suffix') || '');
  }

  function animate(el) {
    var target = parseFloat(el.getAttribute('data-count')) || 0;
    var suffix = el.getAttribute('data-suffix') || '';
    var duration = 1600;
    var start = null;

    /* Fallback: gdy rAF jest dławiony (karta w tle, oszczędzanie energii),
       po czasie animacji i tak pokaż wartość docelową. */
    var fallback = window.setTimeout(function () {
      setFinal(el);
    }, duration + 500);

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        window.clearTimeout(fallback);
        setFinal(el);
      }
    }

    window.requestAnimationFrame(step);
  }

  function init(scope) {
    var values = (scope || document).querySelectorAll('[data-trust-bar-value]:not([data-animated])');
    if (!values.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      values.forEach(function (el) {
        el.setAttribute('data-animated', '');
        setFinal(el);
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          animate(entry.target);
        });
      },
      { threshold: 0.4 }
    );

    values.forEach(function (el) {
      el.setAttribute('data-animated', '');
      el.textContent = '0' + (el.getAttribute('data-suffix') || '');
      observer.observe(el);
    });
  }

  init(document);

  /* Edytor motywu: reinicjalizacja po ponownym wyrenderowaniu sekcji. */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
